<style lang="less">
@import '@/components/ai/zzl/zzl-ai-workbench.less';
.pdf-export {
  .markdown-body h1 {
    margin-top: 0 !important;
  }
}
</style>
<template>
  <div class="zzl-view-page" style="height:100%;overflow:hidden;display:flex;flex-direction:column;min-height:0;">
    <div class="flex-wrap flex-between" style="height:50px;padding:0 10px;background:linear-gradient(to right,#fff,var(--border));">
      <div class="flex-wrap split5">
        <Select v-model="workpackage_id" filterable style="width:200px" placeholder="选择模块" @on-change="cached=false;onSelectWorkpackage()">
          <OptionGroup v-for="s in stages" :key="s.id" :label="s.name">
            <Option v-for="w in s.workpackages" :key="w.id" :value="w.id" :label="w.name">{{ w.name }}</Option>
          </OptionGroup>
        </Select>
        <Select v-if="!getModuleData" v-model="task_id" filterable style="width:200px" placeholder="选任务" clearable @on-change="cached=false;getData()">
          <Option v-for="t in filterdTasks" :key="t.id" :value="t.id" :label="t.name">{{ t.name }}</Option>
        </Select>
        <i-switch v-model="getModuleData" @on-change="onToggleGetModuleData" /> 获取模块数据
      </div>
      <div class="zzl-view-top-actions flex-wrap">
        <Button class="zzl-view-top-refresh" type="default" @click="getTasks">刷新列表</Button>
        <Button @click="exportPDF" :disabled="!result">导出 PDF</Button>
      </div>
    </div>

    <div class="zzl-view-split" style="flex:1;min-height:0;">
      <div class="zzl-view-left" style="padding:12px;display:flex;flex-direction:column;min-height:0;">
        <Spin v-if="dataLoading" fix size="large">
          <div class="zzl-view-data-loading-text">加载数据中…</div>
        </Spin>
        <div class="zzl-view-left-half zzl-view-left-half--data">
          <div class="flex-wrap flex-between" style="align-items:center;margin-bottom:8px;flex-shrink:0;">
            <div class="zzl-view-section-title" style="margin:0;">数据下载和清理</div>
            <div class="flex-wrap" style="align-items:center;gap:8px;">
              <Button type="primary" icon="md-download" :loading="dataLoading" @click="getData">获取数据</Button>
              <Button type="warning" @click="CopyToClip">复制数据</Button>
            </div>
          </div>
          <div class="zzl-view-left-toolbar" style="margin-bottom:8px;flex-shrink:0;">
            <div class="flex-wrap" style="align-items:center;flex-wrap:wrap;gap:8px;">
              <i-switch v-model="extractForm" size="small" @on-change="cleanData" />
              <span style="font-size:12px;">提取表格</span>
              <i-switch v-model="onlyQuestion" size="small" @on-change="cleanData" />
              <span style="font-size:12px;">隐藏合规项</span>
              <i-switch v-model="hideEmptyTracking" size="small" @on-change="cleanData" />
              <span style="font-size:12px;">隐藏空跟踪</span>
              <span style="font-size:12px;color:var(--subtext2);">字符数 {{ aiText.length }}</span>
            </div>
          </div>
          <div class="zzl-view-left-track flex-wrap split5" style="margin-bottom:8px;align-items:center;flex-wrap:wrap;gap:8px;flex-shrink:0;">
            <span style="font-size:12px;color:#64748b;">跟踪记录</span>
            <BaseDate v-model="tracking_startDate" placeholder="开始日期" />
            <BaseDate v-model="tracking_endDate" placeholder="结束日期" />
            <Button size="small" @click="cleanData" type="primary">清理跟踪记录</Button>
          </div>
          <div class="flex-wrap split5 multi-select-wrap" style="min-height:40px;padding:0 10px;align-items:flex-start;margin-bottom:8px;">
            <span style="line-height:32px;white-space:nowrap;">项目筛选</span>
            <Select
              v-model="filteredProjects"
              multiple
              filterable
              clearable
              placeholder="请选择项目"
              style="width:600px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"
              :max-tag-count="2"
            >
              <Option v-for="p in projects" :value="p" :key="p" :title="p">
                <div style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{ p }}</div>
              </Option>
            </Select>
            <Button @click="filteredProjects = []; cleanData()">清空</Button>
          </div>
          <div class="zzl-view-left-textarea-wrap">
            <Input
              type="textarea"
              :value="aiText"
              :rows="4"
              style="width:100%;flex:1;min-height:0;"
              readonly
              placeholder="获取数据后显示清洗结果"
            />
          </div>
        </div>
        <div class="zzl-view-left-half zzl-view-left-half--prompt">
          <div class="zzl-view-left-prompt-body">
            <AiPromptPanel
              v-model="userText"
              mod="zzl-mgr"
              :textarea-rows="4"
              :hide-mod-hint="true"
              split-head
            >
              <template slot="head-left">
                <div class="zzl-view-section-title flex-wrap" style="margin:0;align-items:baseline;gap:8px;">
                  提示词
                  <span style="font-size:12px;font-weight:400;color:var(--subtext2);">
                    （{{ labelForMod('zzl-mgr') }} · zzl-mgr）
                  </span>
                </div>
              </template>
            </AiPromptPanel>
          </div>
        </div>
      </div>

      <div class="zzl-view-right" style="padding:10px;display:flex;flex-direction:column;min-height:0;">
        <div class="flex-wrap flex-between" style="align-items:center;margin-bottom:6px;">
          <div class="zzl-view-section-title" style="margin:0;">报告</div>
          <div class="zzl-view-right-actions flex-wrap" style="gap:8px;justify-content:flex-end;margin-left:auto;">
            <Button type="primary" icon="md-play" :loading="ai_executings" :disabled="aiText.length < 10" @click="CreateByAI">
              {{ ai_executings ? '生成中…' : (result ? '重新生成' : '生成报告') }}
            </Button>
            <Button v-if="images.length" @click="copyImageAddresses">复制图片地址</Button>
            <Button @click="copyReportMd" :disabled="!result">复制 Markdown</Button>
            <Button @click="exportPDF" :disabled="!result">导出 PDF</Button>
          </div>
        </div>
        <div class="zzl-view-right-report">
          <AiMarkdownStreamPanel
            ref="reportPanel"
            class="pdf-export"
            style="flex:1;min-height:0;"
            :value="result"
            :streaming="ai_executings"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
moment.locale('zh-cn');
import { deepCleanTask, renderEFormMap, extractAttachments } from '@/components/ai/clean';
import mixinPageState from '@/mixins/page_state';
import zzlAiStreamReport from '@/components/ai/zzl/mixins/zzlAiStreamReport';
import AiPromptPanel from '@/components/ai/AiPromptPanel.vue';
import AiMarkdownStreamPanel from '@/components/ai/AiMarkdownStreamPanel.vue';
import {labelForMod} from '@/components/ai/aiPromptModLabels';

export default {
  components: { AiPromptPanel, AiMarkdownStreamPanel },
  mixins: [mixinPageState, zzlAiStreamReport],
  data() {
    return {
      pageStateKey: 'ai_zzl_mgr',
      pageStateFields: ['workpackage_id', 'task_id', 'getModuleData', 'onlyQuestion', 'extractForm', 'tracking_startDate', 'tracking_endDate', 'userText', 'filteredProjects'],
      run: {},
      getModuleData: false,
      stages: [],
      workpackages: [],
      workpackage_id: null,
      stage_id: null,
      hideEmptyTracking: false,
      filteredProjects: [],
      raw_tasks: [],
      steps: [],
      messages: {},
      models: [],
      task_id: '',
      aiText: '',
      cleaned: '',
      model: 'douyin',
      data: '',
      task: {},
      images: [],
      files: [],
      userText: '',
      onlyQuestion: false,
      extractForm: false,
      tracking_startDate: null,
      tracking_endDate: null,
      ai_executings: false,
      dataLoading: false,
      loading: false,
      result: '',
      tasks: [],
      projects: [],
      project_id: 'pid65054f01eabec',
      view: 'recent',
      cached: false,
    };
  },
  computed: {
    filteredWorkpackages() {
      if (this.stage_id) {
        return this.workpackages.filter((w)=>w.stage_id == this.stage_id);
      }
      return this.workpackages;
    },
    filterdTasks() {
      if (this.workpackage_id) {
        return this.tasks.filter((t)=>t.workpackage_id == this.workpackage_id);
      }
      return this.tasks;
    },
  },
  mounted() {
    this.$api.afterLogin(()=>{
      this.getTasks();
    });
  },
  methods: {
    labelForMod,
    onToggleGetModuleData() {
      if (this.getModuleData) {
        this.workpackage_id = this.workpackages[0].id;
       
      } else {
        this.task_id = this.filterdTasks[0].id;
        
      }
    },
    getTasks() {
      this.$api.get('logined_zzl/ai_get_mgr_tasks').then((res)=>{
        let {stages, tasks, workpackages} = res.data.data;

        this.tasks = tasks;
        this.workpackages = workpackages;
        stages.forEach((s)=>{
          s.workpackages = workpackages.filter((w)=>w.stage_id == s.id);
        });
        stages = stages.filter((v)=>v.workpackages.length > 0);
        this.stages = stages;
        this.workpackage_id = this.workpackages[0].id;
        this.task_id = this.filterdTasks[0].id;
        
      });
    },
    getData() {
      this.images = [];
      this.files = [];
      let params = {id: this.task_id};
      if (this.getModuleData) {
        if (!this.workpackage_id) {
          this.Error('请选择模块');
          return;
        }
        params= {};
        params.ids = this.filterdTasks.map((t)=>t.id);
      }
      this.dataLoading = true;
      this.$api.post('logined_zzl/ai_get_mgr_task_data', params).then((res)=>{
        const tasks = res.data.data;

        let projects = [];
        tasks.forEach((t)=>{
          if (!projects.includes(t.projectName)) {
            projects.push(t.projectName);
          }
        });
        this.projects = projects;
        const task = this.tasks.find((t)=>t.id == this.task_id);
        this.raw_tasks = tasks;
        this.task = task;
        this.cleanData();
      }).catch((e)=>{
        console.error(e);
        this.Error(e && e.message ? e.message : '获取失败');
      }).finally(()=>{
        this.dataLoading = false;
      });
    },
    zzlReportPdfStem() {
      return `mgr_${moment().format('YYYYMMDD')}`;
    },
    onSelectWorkpackage() {
      if (this.getModuleData) {
        this.getData();
      } else {
        if (this.filterdTasks.length > 0) {
          this.task_id = this.filterdTasks[0].id;
          this.getData();
        } else {
          this.Error('没有找到任务');
        }
      }
    },
    cleanData() {
      this.__savePageState();
      const task = this.task;

      let tasks = this.raw_tasks;
      if(this.filteredProjects.length > 0){
        tasks = tasks.filter((t)=>this.filteredProjects.includes(t.projectName));
      }

      const eformmap = {};
      this.cleaned = tasks.map((t)=>`项目:${t.projectName}\n`+deepCleanTask(t, this.tracking_startDate, this.tracking_endDate, null, this.extractForm?eformmap:null, this.onlyQuestion, this.hideEmptyTracking)).join('\n\n');
      const formstr = renderEFormMap(eformmap);
      this.aiText = `以下为任务[${task.name}]的执行情况 \n ${this.extractForm && formstr?('#因存在相同的表单，对相同表单进行提取。后续数据按照key展示。\n'+formstr+'\n'):''}# 以下是任务数据:\n` +this.cleaned;
      const {images, files, text} = extractAttachments(this.aiText);
      this.images =images;
      this.files =files;
      this.aiText = text;
    },
    async CopyToClip() {
      const text = this.aiText || '';
      try {
        if (navigator.clipboard) {
          await navigator.clipboard.writeText(text);
        } else {
          const textarea = document.createElement('textarea');
          textarea.value = text;
          document.body.appendChild(textarea);
          textarea.select();
          const successful = document.execCommand('copy');
          if (!successful) {
            throw new Error('复制失败');
          }
          console.log(this.Success);

          document.body.removeChild(textarea);
        }
        this.Success('复制成功');
        return true;
      } catch (err) {
        console.error('复制失败:', err);
        return false;
      }
    },
  },
};
</script>

<style>
.image-container{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 5px;
  width: 200px;
  height: 170px;
}
.image-container img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.image-label{
  font-size: 12px;
  color: #666;
  text-align: center;
}

/* 多选框标签自动换行 */
.multi-select-wrap .ivu-select-selection {
  height: auto !important;
  min-height: 32px;
}
.multi-select-wrap .ivu-tag {
  margin: 3px 4px 3px 0;
  max-width: 100%;
}
</style>
